import { render, staticRenderFns } from "./NewModal.vue?vue&type=template&id=1b3729b4&scoped=true&"
import script from "./NewModal.vue?vue&type=script&lang=js&"
export * from "./NewModal.vue?vue&type=script&lang=js&"
import style0 from "./NewModal.vue?vue&type=style&index=0&id=1b3729b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3729b4",
  null
  
)

export default component.exports